import React from 'react';

import { SVGComponentProps } from './svg.types';

const AlignTopSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3959 2.3335C12.6375 2.3335 12.8334 2.13762 12.8334 1.896C12.8334 1.65437 12.6375 1.4585 12.3959 1.4585H1.60425C1.36263 1.4585 1.16675 1.65437 1.16675 1.896C1.16675 2.13762 1.36263 2.3335 1.60425 2.3335H12.3959ZM5.01675 13.1252C5.5068 13.1252 5.75182 13.1252 5.939 13.0298C6.10361 12.9459 6.23749 12.812 6.32137 12.6474C6.41675 12.4602 6.41675 12.2152 6.41675 11.7252V5.4835C6.41675 4.99345 6.41675 4.74843 6.32137 4.56125C6.23749 4.39661 6.10361 4.26275 5.939 4.17887C5.75182 4.0835 5.5068 4.0835 5.01675 4.0835H4.90008C4.41003 4.0835 4.16501 4.0835 3.97784 4.17887C3.8132 4.26275 3.67934 4.39661 3.59545 4.56125C3.50008 4.74843 3.50008 4.99345 3.50008 5.4835V11.7252C3.50008 12.2152 3.50008 12.4602 3.59545 12.6474C3.67934 12.812 3.8132 12.9459 3.97784 13.0298C4.16501 13.1252 4.41003 13.1252 4.90008 13.1252H5.01675ZM10.6057 8.94646C10.4185 9.04183 10.1735 9.04183 9.68342 9.04183H9.56675C9.07669 9.04183 8.83169 9.04183 8.6445 8.94646C8.47988 8.86257 8.34601 8.7287 8.26212 8.56408C8.16675 8.37689 8.16675 8.13189 8.16675 7.64183V5.4835C8.16675 4.99345 8.16675 4.74843 8.26212 4.56125C8.34601 4.39661 8.47988 4.26275 8.6445 4.17887C8.83169 4.0835 9.07669 4.0835 9.56675 4.0835H9.68342C10.1735 4.0835 10.4185 4.0835 10.6057 4.17887C10.7703 4.26275 10.9042 4.39661 10.988 4.56125C11.0834 4.74843 11.0834 4.99345 11.0834 5.4835V7.64183C11.0834 8.13189 11.0834 8.37689 10.988 8.56408C10.9042 8.7287 10.7703 8.86257 10.6057 8.94646Z"
        fill="white"
      />
    </svg>
  );
};

export default AlignTopSVG;
